import { debounce as _debounce } from 'lodash';

import fetchKioskInventory from './fetchKioskInventory';

const fetchKioskInventoryDebounce = _debounce(fetchKioskInventory, 350);

export default fetchKioskInventoryDebounce;
